<template>
	<div> 
	<v-list flat color="lightGrey" class="pa-4 rounded-lg">
		<h5 class="cn-font grey--text mb-2">Übersicht</h5>
		<v-list-item dense>
			<v-list-item-icon>
				<v-icon>mdi-account</v-icon>
			</v-list-item-icon>
			<v-list-item-content>
				<v-list-item-title>{{user.display_name}}</v-list-item-title>
				<v-list-item-subtitle>Gruppenleiter</v-list-item-subtitle>
			</v-list-item-content>
		</v-list-item>
		<v-list-item dense>
			<v-list-item-icon>
				<v-icon>mdi-account-group</v-icon>
			</v-list-item-icon>
			<v-list-item-content>
				<v-list-item-title>
					{{memberCount}} Mitarbeiter
				</v-list-item-title>
			</v-list-item-content>
		</v-list-item>
		<v-list-item dense>
			<v-list-item-icon>
				<v-icon>mdi-clipboard-flow</v-icon>
			</v-list-item-icon>
			<v-list-item-content>
				<v-list-item-title>
					{{groupCollabs.length}} Mitarbeiterumfrage<span v-if="groupCollabs.length > 1">n</span>
				</v-list-item-title>
			</v-list-item-content>
		</v-list-item>
		<v-list-item dense>
			<v-list-item-icon>
				<v-icon>{{videoIcon}}</v-icon>
			</v-list-item-icon>
			<v-list-item-content>
				<v-list-item-title>
					Video meeting room {{group.video_enabled ? 'AUS' : 'AN'}}
				</v-list-item-title>
			</v-list-item-content>
			<v-list-item-action>
				<v-switch color="green" v-model="group.video_enabled"></v-switch>
			</v-list-item-action>
		</v-list-item>
	</v-list>
	<p class="overline mt-2"><DateNote :date="lastLogin" name="Last login"></DateNote></p>
</div>
</template>


<style lang="less">
	
</style>

<script type="text/javascript">
	import Vuex from "vuex";
	import DateNote from "@/components/elements/DateNote"
	export default {
		name: "GroupOverview", 
		props: {
			id: {type: String}
		},
		data: () => {
			return {

			}
		},
		components: {
			DateNote
		},
		computed: {
			...Vuex.mapState({
				groups: state => state.groups,
				user: state => state.user,
				users: state => state.users,
				collaborations: state => state.collaborations
			}),
			memberCount(){
				return this.group.members.length;
			},
			groupCollabs(){
				var id = this.id
				return this.collaborations.filter( c => c.members.indexOf(id) > -1 )
			},
			group(){
				var id = this.id
				return this.groups.find( g => g.id == id )
			},
			videoIcon(){
				if( this.group.video_enabled ){
					return "mdi-television"
				}
				return "mdi-television-off"
			},
			lastLogin(){
				var member_ids = this.group.members;
				var users = this.users;
				var members = member_ids.map( m => users.find(u => u.id == m ) ).filter(m => m.last_login);
				if( members.length ){
					return new Date(Math.max.apply(null, members.map(function(m) {
						return new Date(m.last_login);
					})));
				}
				return false;
			}
		},
		// methods: {
		// }
		// created(){
			
		// }

	}
</script>